import * as React from 'react';

import TrackingModel from 'src/model/trackingInfo.model';

import EmptyTracking from 'src/components/TrackingInfo/components/EmptyTracking';
import TrackingHeader from './components/TrackingHeader';
import TrackingRow from './components/TrackingRow';

import './TrackingTable.scss';

interface ISortTrack {
  label: string;
  sortBy: string;
}

interface ITrackingTableProps {
  t: any;
  headers: ISortTrack[];
  trackings: TrackingModel[];
  sortBy: string;
  sortIn: 'ASC' | 'DESC' | 'AUTO';
  handleSort: (sortBy: string, sortIn: string) => void;
}

class TrackingTable extends React.Component<ITrackingTableProps, any> {
  constructor(props: ITrackingTableProps) {
    super(props);
  }

  private renderTableHeader = (): JSX.Element[] => {
    const headers: JSX.Element[] = [];

    this.props.headers.map((header, index) => {
      headers.push(
        <TrackingHeader
          key={index}
          header={header}
          orderIn={this.props.sortIn}
          orderBy={this.props.sortBy}
          setOrderColumn={this.props.handleSort}
        />
      );
    });
    return headers;
  };

  private renderTableItems = (): JSX.Element[] => {
    const items: JSX.Element[] = [];

    this.props.trackings.map((tracking, index) => {
      items.push(<TrackingRow key={index} tracking={tracking} />);
    });

    return items;
  };

  public render() {
    const { t } = this.props;

    if (this.props.trackings.length === 0) {
      return (
        <React.Fragment>
          <br />
          <div className="rp-tracking-table-empty">
            <EmptyTracking />
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <div className={`rp-tracking-table`}>
          <div className={'rp-tracking-table--headers'}>
            {this.renderTableHeader()}
          </div>
          {this.renderTableItems()}
        </div>
      );
    }
  }
}

export default TrackingTable;
